/* Move the info cards into the right-hand column (below payment / COD button and the 'Need help choosing?' text) and open the first one. */
(function () {
  'use strict';
  function init() {
    var wrap = document.querySelector('.pdp-details');
    if (!wrap || wrap.hasAttribute('data-cards-init')) return;
    wrap.setAttribute('data-cards-init', '');

    var info = document.querySelector('.pdp-info');
    if (info) {
      var features = info.querySelector('.pdp-features');
      if (features && features.parentNode === info) {
        features.insertAdjacentElement('afterend', wrap);
      } else {
        info.appendChild(wrap);
      }
    }

    var first = wrap.querySelector('.pdp-card');
    if (first && !wrap.querySelector('.pdp-card[open]')) first.setAttribute('open', '');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
